import { AddDelegate } from './AddDelegate';

export const Delegate = {
  AddDelegate,
};
